// extracted by mini-css-extract-plugin
module.exports = {"ask":"e_3wb","askText":"e_4wb","askTitle":"e_5wb","askFine":"e_6wb","askBtn":"e_7wb","askLink":"e_8wb"};